import { Entity } from '@data-client/rest';
import { ISODate } from '../utils/transforms';
class UserDeviceEntity extends Entity {
    constructor() {
        super(...arguments);
        this.cityName = null;
        this.countryName = null;
        this.creationDTTM = new Date(0);
        this.deviceGeneratedGUID = null;
        this.deviceName = null;
        this.deviceTypeId = 0;
        this.deviceVersion = null;
        this.locationUpdatedDTTM = null;
        this.status = null;
        this.territoryName = null;
        this.userDeviceId = 0;
        this.userId = null;
    }
    pk() {
        return this.userDeviceId.toString();
    }
}
UserDeviceEntity.schema = {
    creationDTTM: ISODate,
    locationUpdatedDTTM: ISODate
};
UserDeviceEntity.key = 'UserDevice';
export { UserDeviceEntity };
